<template>
  <div class="imgview">
    <img :src="picUrl" style="width:100%;object-fit: contain;" alt=""  usemap="#plantmap">
    <span v-if="index==2" style="position: absolute;top: 308px;left: 46px;">{{sdworkerName}}</span>
  </div>
</template>

<script>
export default {
  data() {
    return {
      picUrl: "",
      index:0 ,
      sdworkerName:''
    };
  },
  mounted() {
    console.log(this.$route.params.index, this.$route.params);
    if (this.$route.params.period == 1) {
      switch (this.$route.params.index + "") {
        case "3":
          this.picUrl = require("../assets/draw/hetianxia.jpg");
          break;
        case "4":
          this.picUrl = require("../assets/draw/rerongji.jpg");
          break;
        case "5":
          this.picUrl = require("../assets/draw/furongwang.jpg");
          break;
        case "6":
          this.picUrl = require("../assets/draw/guolvqi.jpg");
          break;
        case "7":
          this.picUrl = require("../assets/draw/shouji.jpg");
          break;
        case "8":
          this.picUrl = require("../assets/draw/hongbao.jpg");
          break;
        default:
          break;
      }
    } else if (this.$route.params.period == 2) {
      switch (this.$route.params.index + "") {
        case "3":
          this.picUrl = require("../assets/draw/yan.jpg");
          break;
        case "4":
          this.picUrl = require("../assets/draw/liangxi.jpg");
          break;
        case "5":
          this.picUrl = require("../assets/draw/youka.jpg");
          break;
        case "6":
          this.picUrl = require("../assets/draw/guolvqi.jpg");
          break;
        case "7":
          this.picUrl = require("../assets/draw/shouji.jpg");
          break;
        case "8":
          this.picUrl = require("../assets/draw/hongbao.jpg");
          break;
        default:
          break;
      }
    } else if (this.$route.params.period == 3) {
      this.index=this.$route.params.index;
      this.sdworkerName=this.$route.params.name
      switch (this.$route.params.index + "") {
        case "1":
          this.picUrl = require("../assets/draw3/基金会会员.png");
          break;
        case "2":
          this.picUrl = require("../assets/draw3/捐赠证书.jpg");
          break;
        case "3":
          this.picUrl = require("../assets/draw3/年货礼包.jpg");
          break;
        case "4":
          this.picUrl = require("../assets/draw3/旺旺大礼包.jpg");
          break;
        case "5":
          this.picUrl = require("../assets/draw3/年货礼包and旺旺大礼包.jpg");
          break;
        case "6":
          this.picUrl = require("../assets/draw3/fudai.jpg");
          break;
        default:
          break;
      }
    } 
  },
  created() {},
};
</script>

<style scoped>
.imgview{
  display: flex;
}
</style>>
